export function initCustomModal() {
  const applyNowButtons = document.querySelectorAll('.apply-now');
  const modalCloseButtons = document.querySelectorAll('.modal-close');
  const modalContent = document.querySelector('.modal-content-wrapper');

  applyNowButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      document.documentElement.classList.add('modal-open');
    });
  });

  modalCloseButtons.forEach((button) => {
    button.addEventListener('click', function () {
      document.documentElement.classList.remove('modal-open');
    });
  });

  // Close when clicking anywhere outside the modal
  document.addEventListener('click', function (event) {
    // Modal is not open
    if (!document.documentElement.classList.contains('modal-open')) {
      return;
    }

    // Ignore clicks on Apply button
    if (event.target.closest('.apply-now')) {
      return;
    }

    // Ignore clicks inside the modal
    if (event.target.closest('.modal-content-wrapper')) {
      return;
    }

    // Close modal
    document.documentElement.classList.remove('modal-open');
  });
}

